module.exports = __webpack_public_path__ + "img/geod_6.7dfa82bb.jpg";